export default __webpack_public_path__ + "static/media/glass_resin_stained.29cc4c2b.JPG";